import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/mlap'

Styxie.Initializers.MlapSettingsAudits = {
  index: async(props) => {
    const { default: AuditsSettings } = await import('@/vue_widgets/mlap/settings/audits/index.vue')
    createVueApp(AuditsSettings, { props, sidebar })
  }
}
